function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/play-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3125 39C7.3125 21.4995 21.4995 7.3125 39 7.3125C56.5005 7.3125 70.6875 21.4995 70.6875 39C70.6875 56.5005 56.5005 70.6875 39 70.6875C21.4995 70.6875 7.3125 56.5005 7.3125 39ZM52.8911 35.804C55.3986 37.1971 55.3986 40.8032 52.8911 42.1963L34.6819 52.3125C32.2449 53.6664 29.25 51.9042 29.25 49.1164V28.8839C29.25 26.0961 32.2449 24.3339 34.6819 25.6878L52.8911 35.804Z",
    fill: "#DBDBDB",
    style: {
      fill: "#DBDBDB",
      fill: "color(display-p3 0.8588 0.8588 0.8588)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.86cd4f44ec6bbc3e2ff839e3689ed921.svg";
export { ForwardRef as ReactComponent };